module.exports = __webpack_public_path__ + "assets/img/SD-WAN-all.4ef8520f.png";